import { FormAddressField } from 'components/ui/controlled-form/FormAddressField/index.js';
import { FormInput } from 'components/ui/form/FormInput/index.js';
import type { Control } from 'react-hook-form';

import { IssueFormRow } from '../components/IssueFormRow.js';

type Props = {
  control: Control<any>;
};

export const IssueFormSupplier = ({ control }: Props) => {
  return (
    <>
      <IssueFormRow control={control} field="supplier.siteName">
        {props => (<FormInput {...props} />)}
      </IssueFormRow>
      <IssueFormRow control={control} field="supplier.siteAddress">
        {props => (<FormAddressField {...props} />)}
      </IssueFormRow>
    </>
  );
};
